
import React from "react";

import "../css/App.scss";

class ErrorRender extends React.Component {

    render() {
        if ( this.props.match.params['code'] === '404') {
            return (
                <div>
                    <div>
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="banner-content">
                                        <h1>Page doesnt exist</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>);
        } else {
            return (
                <div>
                    <div>
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="banner-content">
                                        <h1>Something went wrong</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}
export default ErrorRender;
